
import { useState } from 'react';
import StaffSheetForm from './StaffSheetForm/StaffSheetForm';
import PDFDisplay from './PDFDisplay/PDFDisplay'
import './App.css';

import styled from 'styled-components';

const AppContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`

const HalfContainer = styled.div`
  width: 50vw;
  height: 100vh;
`

const FormContainer = styled(HalfContainer)`
  box-shadow: 16px 0px 32px rgba(0, 0, 0, 0.25);
  z-index: 15;
`;

const PDFDisplayContainer = styled(HalfContainer)`
  background-color: #617E60;
  zIndex: -5;
`;

function App() {
  const [ values, setValues] = useState()

  return (
    <AppContainer className="App">
      <FormContainer>
        <StaffSheetForm valuesSet={setValues}/>
      </FormContainer>
      <PDFDisplayContainer>
        <PDFDisplay formValues={values}/>
      </PDFDisplayContainer>
    </AppContainer >
  );
}

export default App;
